export const GET_COURIER_LISTS = "GET_COURIER_LISTS";
export const GET_COURIER_LIST_BY_ID = "GET_COURIER_LIST_BY_ID";
export const UPDATE_COURIER_LIST = "UPDATE_COURIER_LIST";
export const DELETE_COURIER_LIST = "DELETE_COURIER_LIST";
export const CREATE_COURIER_LIST = "CREATE_COURIER_LIST";
